import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes([
  'FILES_PAGE_LIST_RESET',
  'FILES_PAGE_LIST_PUSH',
  'FILES_PAGE_SET_SEARCH',
  'FILES_PAGE_REMOVE_FILE_FROM_LIST',
  'FILES_PAGE_ADD_DOWNLOAD_URL_FOR_FILE',
  'FILES_PAGE_LIST_REPLACE',
  'CHANGE_FILE_IN_LIST',
  'ADD_FILE_TO_LIST',
]);
